import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section id="faq" className="w-full bg-background-50 py-12 md:py-16">
      <div className="px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-10">
            <div className="lg:col-span-1">
              <span className="inline-flex items-center gap-1.5 text-accent-700 text-sm font-medium">
                <i className="ri-question-answer-line text-base leading-none"></i>
                常见问题
              </span>
              <h2 className="mt-2 font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
                看之前常被问到的几件事
              </h2>
              <p className="mt-3 text-foreground-600 text-sm leading-relaxed">
                关于结论的性质、疑点与结论的区别、素材被收录后怎么处理，都放在这里统一说明。
              </p>
              <div className="mt-6 rounded-lg bg-accent-50 border border-accent-200 p-4 md:p-5">
                <p className="flex items-start gap-2 text-accent-900 text-sm leading-relaxed">
                  <i className="ri-error-warning-line text-base leading-none mt-0.5 flex-shrink-0"></i>
                  本站内容仅作公开素材的细节观察与复核交流，不构成对任何个人或机构的定性评价。
                </p>
              </div>
            </div>

            <div className="lg:col-span-2">
              <div className="flex flex-col gap-3">
                {faqs.map((item) => {
                  const open = openId === item.id;
                  return (
                    <div
                      key={item.id}
                      className={`rounded-lg border transition-colors ${
                        open
                          ? "bg-background-100 border-primary-200"
                          : "bg-background-100/60 border-background-200"
                      }`}
                    >
                      <button
                        type="button"
                        onClick={() => setOpenId(open ? null : item.id)}
                        className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left cursor-pointer"
                      >
                        <span className="font-heading font-semibold text-foreground-950 text-sm md:text-base">
                          {item.q}
                        </span>
                        <i
                          className={`${
                            open ? "ri-subtract-line" : "ri-add-line"
                          } text-primary-600 text-lg leading-none flex-shrink-0`}
                        ></i>
                      </button>
                      {open && (
                        <div className="px-4 md:px-5 pb-4 md:pb-5">
                          <p className="text-foreground-600 text-sm leading-relaxed border-t border-background-200 pt-3">
                            {item.a}
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}